import { RadioRow, RadioRowGroup } from "kubra-ux-forge";
import React from "react";
import triangleWarning from "assets/icons/triangle_exclamation.svg";
import { useField } from "formik";

interface BooleanFieldProps {
  labelYes: string;
  labelNo: string;
  name: string;
}

export const BooleanField: React.FC<BooleanFieldProps> = ({
  name,
  labelYes,
  labelNo,
}) => {
  // TODO: confirm if boolean field can have placeholder?
  // TODO: confirm if boolean field can be read-only?

  const [field, meta, helpers] = useField(name);

  const handleSelect = (value: boolean) => {
    helpers.setValue(value);
  };

  const showError = meta.touched && meta.error;

  // TODO: fix the design as it doesn't match Figma.

  return (
    <>
      <div className="boolean-field-label">
        <span>{name}</span>
      </div>

      <div className="radio-group" aria-invalid={meta.touched && !!meta.error}>
        <RadioRowGroup ariaLabel={name}>
          <RadioRow
            selected={field.value === true}
            label={labelYes}
            onSelect={() => handleSelect(true)}
          />
          <RadioRow
            selected={field.value === false}
            label={labelNo}
            onSelect={() => handleSelect(false)}
          />
        </RadioRowGroup>
      </div>

      {showError && (
        <div className="boolean-field">
          <img
            src={triangleWarning}
            alt="error"
            aria-hidden={true}
            width="19"
            height="19"
          />
          <div className="errorText" style={{ marginLeft: "3px" }}>
            {meta.error}
          </div>
        </div>
      )}
    </>
  );
};
